export const MANAGE_EMAIL = 'manageEmail';
export const SEND_USER_EMAIL = `${MANAGE_EMAIL}/SendEmail`;

